import { Context, createContext, useCallback, useState } from 'react'

import { Box, Button, Modal, Text } from '@fairfashion/design-system'

interface ConfirmModalProviderProps {
  children: React.ReactNode
}

interface ConfirmModalContextType {
  confirmModal: (title: string, text: string) => Promise<boolean>
}

export const ConfirmModalContext: Context<ConfirmModalContextType> =
  createContext({
    // eslint-disable-next-line
    confirmModal: (title: string, text: string) =>
      new Promise((resolve) => resolve(false)),
  })

export const ConfirmModalProvider = ({
  children,
}: ConfirmModalProviderProps) => {
  const [title, setTitle] = useState<string>('')
  const [text, setText] = useState<string>('')
  const [open, setOpen] = useState(false)
  const [confirmResolve, setConfirmResolve] = useState<
    ((success: boolean) => void) | null
  >(null)

  const confirmModal = useCallback(
    (title: string, text: string): Promise<boolean> => {
      setTitle(title)
      setText(text)
      setOpen(true)
      return new Promise((resolve) => {
        setConfirmResolve(() => resolve)
      })
    },
    [],
  )

  const closeModal = (success: boolean) => {
    if (confirmResolve) {
      confirmResolve(success)
    }
    setOpen(false)
    setConfirmResolve(null)
  }

  return (
    <ConfirmModalContext.Provider value={{ confirmModal }}>
      {children}
      <Modal
        title={title}
        open={open}
        onClose={() => setOpen(false)}
        width="500px"
        maxWidth="90%"
      >
        <Box direction="column" gap={5} paddingTop={3} width="100%">
          <Text color="grey_2">{text}</Text>
          <Box gap={1} justifyContent="flex-end" width="100%">
            <Button onClick={() => closeModal(false)} variant="outlined">
              Cancelar
            </Button>
            <Button onClick={() => closeModal(true)}>Confirmar</Button>
          </Box>
        </Box>
      </Modal>
    </ConfirmModalContext.Provider>
  )
}
